export const BOXPLOT_METRICS_SET = new Set([
  "MEAN-Mbps",
  "SUBS-ACTIVE",
  "RTT-80%-ms",
  "RTT-MED-ms",
  "RTT-MIN-ms",
  "RTX",
  "CONGEST",
]);

export function getParsedDataSubs(rows, headerMap, subsGroups, subsTypes) {
  const subGroupsSet = new Set(subsGroups);
  const parsedData = rows.reduce(
    (acc, row, indexRow) => {
      const [nameGroup, ...attrs] = row.split(/\s+/);
      if (nameGroup && subGroupsSet.has(nameGroup)) {
        acc.names.push(nameGroup);
        const item = [nameGroup, ...attrs].reduce(
          (accItem, attr, index) => {
            const attrName = headerMap[index];
            accItem[attrName] = attr;
            if (nameGroup !== "all-subscribers") {
              if (BOXPLOT_METRICS_SET.has(attrName)) {
                if (acc[attrName]) {
                  acc[attrName].push(attr);
                } else {
                  acc[attrName] = [attr];
                }
              }
            }
            return accItem;
          },
          { "GROUP-TYPE": subsTypes[nameGroup], id: indexRow }
        );
        acc.totalGroups += 1;
        acc.newRows.push(item);
      }

      return acc;
    },
    { newRows: [], names: [], totalGroups: 0 }
  );

  return parsedData;
}